import React from 'react';
import moment from 'moment';
import { GetBrandedLogo, GetBrandedLogoAltText } from '../../../services/BrandingService';

export default class ReportPrintHeader extends React.Component {
  constructor (props){
    super(props);

    this.state = {
      logo: GetBrandedLogo(),
      logoAltText: GetBrandedLogoAltText()
    }
  }

  render() {
    let { reportType, selectedStudent, selectedClass, school, style } = this.props;
    let reportName = reportType && (reportType.charAt(0).toUpperCase() + reportType.slice(1).toLowerCase() + " Report for ") + (selectedStudent ? selectedStudent.label : selectedClass)
    let schoolName = school && school[0] && school[0].label;

    // do not render for Parent report if this is the "main" ReportPrintHeader
    // ReportPrintHeader is rendered again within the Parent report's Content

    if (this.props.isMain && ['PARENT', 'READINGROPE', 'PROGRESS'].includes(reportType)) return null

    // overwrite reportName if props.title is present
    if (this.props.title) reportName = this.props.title

    return (
      <div className="reportPrintHeader">
        <div className="reportName" style={style}>{reportName}</div>
        <div className="home"><img className="amiraLogo" src={this.state.logo} alt={this.state.logoAltText} /></div>
      </div>
    );
  }
}
